import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-05/lesson-22/task-03";

const task: Slide = {
  titleHtml:
    "The impact sound pressure levels are measured in the receiving room. If some sound-<br>absorbing material is added into the receiving room, the correct statement is:",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
